import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';

import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';

// undefined while the real ACL is loading (placeholder grants everything)
export const useCanViewSchufa = (leadId: string): boolean | undefined => {
    const { isPending, isPlaceholderData, permissions } = useAclPermissions({ loanRequestId: leadId });
    if (isPending || isPlaceholderData) return undefined;
    return permissions.resolvers[AGGREGATE_NAMES.LOAN_REQUEST][LOAN_REQUEST_RESOLVERS.getSchufa];
};
